const dateTimeStyle = {
    datePicker: {
        width: 151,
        fontSize: 14,
        marginTop: 16
    },
    timePicker: {},
    timePickerField: {
        width: 40,
        height: 'auto'
    },
    timePickerInput: {
        fontSize: 14,
        marginTop: 0,
        marginBottom: 14,
        textAlign: 'center'
    },
    timePickerLabel: {
        fontSize: 16,
        height: 18,
        lineHeight: 1.5,
        color: '#777',
        top: 25,
        left: -17,
        width: 14,
        textAlign: 'center'
    }
};

export default dateTimeStyle;


// WEBPACK FOOTER //
// src/components/ui/date-time-style.js